import React, {FC, useState} from 'react'
import {useTranslation} from 'react-i18next'

import Page from 'src/designSystem/components/organisms/Page/Page'
import PFText from 'src/designSystem/components/atoms/PFText/PFText'
import {RadioButtonList} from 'src/designSystem/components/molecules/RadioButtonList/RadioButtonList'
import Box from 'src/designSystem/components/atoms/Box/Box'

type Props = {
  onComplete: () => Promise<void>
}

export const ProhibitedBusinessMethodsTemplate: FC<Props> = ({onComplete}) => {
  const {t} = useTranslation(['ProhibitedBusinessMethods', 'Common'])
  const [selectedOption, setSelectedOption] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const options = [
    {
      id: 'option-1-radio-button',
      text: t('Common:Yes'),
    },
    {
      id: 'option-2-radio-button',
      text: t('Common:No'),
    },
  ]

  const handleOnPress = (value: string): void => {
    setSelectedOption(value)
  }

  const handleOnComplete = async (): Promise<void> => {
    setIsLoading(true)
    try {
      await onComplete()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Page
      buttonProps={{
        type: 'singleButton',
        primary: {
          text: t('Common:Next'),
          onPress: handleOnComplete,
          testID: 'ProhibitedBusinessMethodsTemplate-primaryButton',
          disabled: selectedOption === '' || isLoading,
          loading: isLoading,
        },
      }}
      variant={'generic'}
      title={t('Title')}
      testID={'ProhibitedBusinessMethodsTemplate-page'}
      smallTopGap
    >
      <Box marginBottom="small">
        <PFText variant={'p'}>{t('Description')}</PFText>
      </Box>
      <RadioButtonList options={options} onPress={handleOnPress} selectedOption={selectedOption} />
    </Page>
  )
}
